// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1N3bv","colMin":"styles_colMin__RRBy3"};